module.exports = __webpack_public_path__ + "static/media/xyeld-matic.135ca2ff.svg";